import { createStore, applyMiddleware, combineReducers, compose } from "redux"
import { all } from 'redux-saga/effects'
import { connectRouter, routerMiddleware } from "connected-react-router"
import createSagaMiddleware from 'redux-saga'
import { createBrowserHistory } from "history"

/*** Reducers ***/
import home           		from "../modules/home/Reducer"
import app            		from "../modules/app/Reducer"
import contact        		from "../modules/contact/Reducer"
import login          		from "../modules/login/Reducer"
import producers      		from "../modules/admin/producers/Reducers"
import getProducer    		from "../modules/producer/Reducer"
import producerLanginPage from '../modules/producer_landing_page/Reducer'

/*** Sagas ***/
import ContactSagas 						from '../modules/contact/Sagas'
import LoginSagas   						from '../modules/login/Sagas'
import ProducerSagas  					from '../modules/admin/producers/Sagas'
import ProducerSaga   					from '../modules/producer/Saga'
import ProducerLanginPageSaga   from '../modules/producer_landing_page/Saga'

export const history = createBrowserHistory()
const sagaMiddleware = createSagaMiddleware()


const rootReducer = combineReducers({
	home,
	app,
	contact,
	login,
	producers,
	getProducer,
	producerLanginPage,
  router: connectRouter(history)
})

const middlewares = [routerMiddleware(history),sagaMiddleware];

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // eslint-disable-line

export const store = createStore(
  rootReducer,
  composeEnhancer(applyMiddleware(...middlewares))
)

export default function* rootSagas() {
	yield all([
		ContactSagas(),
		LoginSagas(),
		ProducerSagas(),
		ProducerSaga(),
		ProducerLanginPageSaga()
	])
} 
sagaMiddleware.run(rootSagas)